import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'filter',
  standalone: false
})
export class FilterPipe implements PipeTransform {
  transform(items: any[], property: string, value?: any): any[] {
    if (!items || !property) {
      return items;
    }

    if (value === undefined) {
      // Filtrar por propriedade truthy
      return items.filter(item => item[property]);
    }

    // Filtrar por valor específico
    return items.filter(item => item[property] === value);
  }
}





